import { ProductAllergiesType } from "../../types/types";
import APIService from "./APIService";

class CustomerService extends APIService {
  add = async (
    first_name: string,
    last_name: string,
    email: string,
    contact_no: string,
    household_member_count: Number,
    ethnicity: string,
    loyalty_number: string,
    membership_status: string,
    zip_code: string,
    address_1: string,
    address_2: string,
    city: string,
    country: string,
    state: string,
    geolocation: any,
    is_subscribe: boolean,
    gender: string,
    programs: string[],
    product_allergies: string[]
  ) => {
    const result = await this.post(
      {
        first_name,
        last_name,
        email,
        contact_no,
        household_member_count,
        ethnicity,
        loyalty_number,
        membership_status,
        zip_code,
        address_1,
        address_2,
        city,
        country,
        state,
        geolocation,
        is_subscribe,
        gender,
        programs,
        product_allergies
      },
      "customers"
    );
    return result ? result.data : null;
  };

  bulkUpload = async (customer_data: any) => {
    const result = await this.post(
      { customer_data },
      "customers/bulk-upload"
    );

    return result ? result.data : null;
  }

  search = async (search: string = "", page: number = 1, limit: number = 10, sort: string) => {
    const result = await this.get("customers/search?generic=" + search + "&page=" + page + "&limit=" + limit + "&sort=" + sort);
    return result ? result.data : null;
  };

  edit = async (
    first_name: string,
    last_name: string,
    email: string,
    contact_no: string,
    household_member_count: Number,
    ethnicity: string,
    loyalty_number: string,
    membership_status: string,
    zip_code: string,
    address_1: string,
    address_2: string,
    city: string,
    country: string,
    state: string,
    geolocation: any,
    is_subscribe: boolean,
    id: string,
    gender: string,
    programs: string[],
    product_allergies: string[]
  ) => {
    const result = await this.put(
      {
        first_name,
        last_name,
        email,
        contact_no,
        household_member_count,
        ethnicity,
        loyalty_number,
        membership_status,
        zip_code,
        address_1,
        address_2,
        city,
        country,
        state,
        geolocation,
        is_subscribe,
        gender,
        programs,
        product_allergies
      },
      "customers/" + id
    );
    return result ? result.data : null;
  };

  delete = async (id: string) => {
    const result = await this.remove("customers/" + id);
    return result ? result.data : null;
  };

  getCustomers = async (query: string) => {
    const result = await this.get("customers/get-customers?query=" + query);
    return result ? result.data : null;
  };

  getCustomerDetails = async (id: string) => {
    const result = await this.get("customers/" + id);
    return result ? result.data : null;
  };
}

export default CustomerService;
